import React from "react";

// A grouped icon-button cluster used on studio editor pages.
// Desktop / Mobile toggle the preview width; Breakout opens a fullscreen
// preview. Active cells fill black; the breakout cell highlights while
// the fullscreen overlay is open.
const ViewControls = ({ mode, setMode, onBreakout, breakoutActive }) => {
  const desktopActive = mode === "desktop";
  const mobileActive = mode === "mobile";

  const cell = (active, onClick, title, ariaPressed, icon) => (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-label={title}
      aria-pressed={ariaPressed}
      className={`w-9 h-9 inline-flex items-center justify-center transition-colors ${
        active ? "bg-black text-white" : "text-slate-600 hover:bg-slate-100"
      }`}
    >
      {icon}
    </button>
  );

  return (
    <div className="inline-flex items-center bg-white border-[2px] border-black divide-x-[2px] divide-black">
      {cell(
        desktopActive,
        () => setMode("desktop"),
        "Desktop preview",
        desktopActive,
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="h-4 w-4">
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 0 1-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0 1 15 18.257V17.25m6-12V15a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 15V5.25m18 0A2.25 2.25 0 0 0 18.75 3H5.25A2.25 2.25 0 0 0 3 5.25m18 0V12a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 12V5.25" />
        </svg>
      )}
      {cell(
        mobileActive,
        () => setMode("mobile"),
        "Mobile preview",
        mobileActive,
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="h-4 w-4">
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5A2.25 2.25 0 0 0 18 20.25V3.75a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
        </svg>
      )}
      {cell(
        breakoutActive,
        onBreakout,
        "Open fullscreen preview",
        undefined,
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" className="h-4 w-4">
          <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15" />
        </svg>
      )}
    </div>
  );
};

export default ViewControls;
